import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Graphics } from './components/Graphics';
import { MoveMenu } from "./components/MoveMenu";


import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { css } from "glamor";
import Toast from "../toast/Toast";
import Move from "./img/move.svg";

import "./RotorAdapters.scss";
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';


export class RotorAdapters extends Component {
constructor(props) {
  super(props);

  this.state = {}

  const interactions = (heldObj, target) => {
    //Don't run if this RotorAdapters not the held object
    if(heldObj.type !== "RotorAdapters" || heldObj.id !== this.props.id){
      return null;
    }
    if (target === undefined || target === null) {
      this.props.setRotorAdaptersOnShelf({
        id: this.props.id,
        onShelf: false
      });
      return null;
    }

          // All Microcentrifuge interactions
          if (target.type === "Microcentrifuge") {
            //Get the targeted TipBox
            const targetMicrocentrifuge = this.props.interactionProps.microcentrifuge[target.id - 1]
            if (targetMicrocentrifuge.isOpen) {

                this.props.setRotorAdaptersInScene({
                  id: this.props.id,
                  inScene: false,
                });

                this.props.setRotorAdaptersOnShelf({
                  id: this.props.id,
                  onShelf: false
                });

                this.props.onMicrocentrifugeInsertRotor({
                  id: target.id,
                  itemId: this.props.id
                })
                this.props.onItemDropCentrifugeMC({
                  id: target.id,
                  itemId: this.props.id,
                  type: "ROTOR",
                })

              // Reset the tube position to a zero transform
              heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"
              heldObj.htmlObj.style.zIndex = null;
              this.props.hideAllControls();

            } else {
              //Alert - open centrifuge
              this.makeToast("WARNING", "You must open the microcentrifuge first.", "Microcentrifuge is closed!")
            }
          }

  }

  Object.defineProperty(interactions, 'name', {value: ('rotorAdapters_interactions_'+this.props.id), configurable: true});
  console.log('interactions: ', interactions);
  this.props.pushInteractions([interactions]);
}

componentWillMount() {
  this.props.createRotorAdapters({
    props: this.props.defaultProps,
  });
}

componentDidMount() {
  window.setTimeout(() => {
    this.movemenu.style.bottom =
      "calc(100% + " + (this.label.offsetHeight + 29) + "px)";
  }, 2000);
}

makeToast = (type, msg, title) => {
  let color = "";
  if (type === "HINT") {
    color = colors.yellow1;
  } else {
    color = colors.red1;
  }

  toast(<Toast type={type} msg={msg} title={title} />,{
    className: css({
      border: "2px solid "+color,
      borderRadius: "6px",
      marginLeft: "-200px",
      minWidth: "400px",
      paddingLeft: 0
    }),
    progressClassName: css({
      background: color
    }),
    position: "top-center",
    autoClose: 5000,
  });
}

showControls = ()=> {
  this.props.hideAllControls();
  this.props.setRotorAdaptersControlVisibility({id: this.props.id, controlsVisible: true});
}

rotorAdaptersSelected = (e) => {

  if(!this.props.controlsVisible){
      this.showControls()
  }

  this.props.setRotorAdaptersHeld({
    id: this.props.id,
    held: true,
  })

  // this.props.setSolutionHeld({
  //   id: this.props.id,
  //   held: true,
  // });
  this.props.setHeldObject({
    id: this.props.id,
    type: "RotorAdapters",
    htmlObj: e.target,
  });

}

rotorAdaptersUnselected = (e) => {
  this.props.setRotorAdaptersHeld({
    id: this.props.id,
    held: false,
  })
}

showMoveMenu = e => {
  this.props.setMoveMenu({
    type: this.props.type,
    connect: this.props.id
  });
  this.props.showMoveMenu({ display: !this.props.moveMenuDisplay });
};

render(){
  return (
      <ul
        style={{
          position: 'absolute',
          display:(!this.props.inScene)?'none':null,
          zIndex: (this.props.controlsVisible)?99:null
        }}>
         <li
            onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.rotorAdaptersSelected() } }
            onMouseDown={this.rotorAdaptersSelected}
            onDragStart={(e) => this.rotorAdaptersSelected(e)}
            onDragEnd={(e) => this.rotorAdaptersUnselected(e)}
            draggable
            tabIndex={0}
            id={"RotorAdapters_"+this.props.id}
            className = {"RotorAdapters draggable droptarget"+ this.props.id}
             style={{
              transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)"
            }}
             >
            <p
              className="label"
              aria-hidden="true"
              ref={(label) => {
                this.label = label;
              }}
            >{this.props.type + ' ' + ((this.props.numberOfAdapters + 1) - this.props.id) + ' of ' + this.props.numberOfAdapters}</p>
            <Graphics id={this.props.id}/>
            <div
              className="move-menu"
              ref={(movemenu) => {
                this.movemenu = movemenu;
              }}
              style={{ display: this.props.controlsVisible ? null : "none" }}
            >
              <button
                tabIndex={0}
                className="move-button"
                onClick={this.showMoveMenu}
                aria-label="Move menu. Select to view the available positions."
              >
                <img src={Move} alt="Move menu icon." />
              </button>
              <MoveMenu type={this.props.type} connect={this.props.id} />
            </div>
          </li>
       </ul>
    );
  }
}


RotorAdapters.propTypes = {
  createRotorAdapters: PropTypes.func,
}

RotorAdapters.defaultProps = {

}
